import R from 'ramda';

export const generateChannelAdvisorWidgetUrl = ({
  selectedSKU,
  url,
  lang,
  caPid,
  campaign,
  newDesign,
}) =>
  `${url}?pid=${caPid}&modelname=${selectedSKU}${campaign || ''}${
    lang ? `&lang=${lang}` : ''
  }${newDesign ? '&type=redesign' : ''}`;

export const validateSku = R.replace(/^0*/, '');
